import { getStore } from '@/reducers/index';
import { getOrCreatePulse } from '@/tools/tracking/utils';

export const trackEvent = (isOpen: boolean): void => {
  const { search: searchState } = getStore(undefined, false).getState();
  const { id: searchId } = searchState;
  const pulseTracker = getOrCreatePulse();

  pulseTracker?.queueEvent(
    {
      type: 'Engagement',
      object: {
        type: 'UIElement',
        '@id': 'sdrn:subito:page:listing:element:ai_faq',
        elementType: 'button',
        url: 'listing',
        label: isOpen ? 'close-FAQ' : 'read-FAQ',
      },
      page: {
        pageType: 'listing',
        pageName: 'listing',
      },
      searchId,
      target: {
        type: 'Listing',
        id: 'listing',
      },
    },
    isOpen ? 'Click su chiudi "FAQ"' : 'Click su espandi "FAQ"'
  );
};
